import { SmartfireComponent } from "@smartfire/gutenberg-react";
import { createElement } from "@wordpress/element";
import { registerFormatType, applyFormat, removeFormat, getActiveFormat } from "@wordpress/rich-text";
import { InspectorControls, PanelColorSettings } from '@wordpress/block-editor';
import commonVars from "./common.module.scss"

const __ = SmartfireComponent.__;


const colorPalette= [                                        
    {name:"primary",
    color: commonVars.primary},
    {name: "secondary",
    color: commonVars.secondary},
    {name:"third",
    color: commonVars.third},
    {name:"success",
    color: commonVars.success},
    {name:"info",
    color: commonVars.info},
    {name: "warning",
    color: commonVars.warning},
    {name:"error",
    color:commonVars.error},
    {name:"basic",
    color:commonVars.basic},
    {name:"text",
    color: commonVars.text},
    {name:"white",
    color: commonVars.white}
]

export default function registerColors(){
    [
        {
            name: 'color',
            title: __('Couleur du texte')
        }
    ].forEach(({ name, title }) => {
        const type = `advanced/${name}`

        registerFormatType(type, {
            title,
            tagName: 'span',
            className: name,
            attributes: {
                style: 'style'
            },
            edit({ isActive, value, onChange }) {
                let activeColor

                if (isActive) {
                    const activeFormat = getActiveFormat(value, type)
                    const style = activeFormat.attributes.style

                    activeColor = style.replace(new RegExp(`^${name}:\\s*`), '')
                }

                return (
                    createElement(InspectorControls, null,
                        createElement(PanelColorSettings, {
                            title,
                            initialOpen: true,
                            colorSettings: [
                                {
                                    value: activeColor,
                                    onChange: (color) => {
                                        if (color) {
                                            onChange(applyFormat(value, {
                                                type,
                                                attributes: {
                                                    style: `${name}:${color}`
                                                }
                                            }))
                                            return
                                        }

                                        onChange(removeFormat(value, type))
                                    },
                                    label: __('Appliquer une couleur au texte sélectionné'),
                                    colors: colorPalette

                                }
                            ]
                        })
                    )
                )
            }
        })
    })
};

export {colorPalette}